import React from "react";
import PropTypes from "prop-types";
import _without from "lodash/without";

import FavoriteStar from "../../../ui/BWGrid/FavoriteStar";

const FavoriteControl = ({
  isStarred,
  favoriteProjectIds,
  projectId,
  actions,
  loading,
}) => {
  const handleToggle = isStarred => {
    const newFavorites = _without(favoriteProjectIds, projectId);
    if (isStarred) {
      newFavorites.push(projectId);
    }
    actions.updateAuthenticatedUser({ favoriteProjectIds: newFavorites });
  };

  return (
    <FavoriteStar
      isStarred={isStarred}
      onClick={handleToggle}
      loading={loading}
    />
  );
};

FavoriteControl.propTypes = {
  isStarred: PropTypes.bool,
  favoriteProjectIds: PropTypes.arrayOf(PropTypes.string),
  projectId: PropTypes.string,
  actions: PropTypes.shape({
    updateAuthenticatedUser: PropTypes.func,
  }),
  loading: PropTypes.bool,
};

export default FavoriteControl;
